module.exports = __webpack_public_path__ + "static/media/support-thumb-3.c0b597b4.jpg";